// extracted by mini-css-extract-plugin
module.exports = {"star-icon":"_5jtwa","starIcon":"_5jtwa","rating":"_3uKSd"};